export const QUERY_PARAM_REFERER = 'ref';
